module.exports = __webpack_public_path__ + "img/Search.0ba4348e.svg";